<ai-dismissible-info-banner
  storageKey="ai-assistant-capability-info-closed"
  icon="auto_awesome"
  [title]="'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.CAPABILITY_INFO.TITLE' | translate"
>
  <div [innerHTML]="'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.CAPABILITY_INFO.CONTENT' | translate"></div>
</ai-dismissible-info-banner>

<form [formGroup]="capabilityForm()" [attr.disabled]="capabilityForm().disabled">
  <glxy-form-field [required]="true">
    <glxy-label>{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.NAME' | translate }}</glxy-label>
    <input matInput formControlName="name" type="text" />
    <glxy-hint>{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.NAME_HELP_TEXT' | translate }}</glxy-hint>
  </glxy-form-field>
  <glxy-form-field>
    <glxy-label>{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.DESCRIPTION' | translate }}</glxy-label>
    <textarea matInput formControlName="description" rows="2"></textarea>
    <glxy-hint>{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.DESCRIPTION_HELP_TEXT' | translate }}</glxy-hint>
  </glxy-form-field>
  <div formArrayName="promptModules">
    @for (promptModule of promptModules(); track promptModule; let iPromptModule = $index) {
      <glxy-form-field [formGroupName]="iPromptModule">
        <glxy-label
          >{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.PROMPT' | translate }}
          <mat-icon
            class="info-icon"
            [glxyTooltip]="'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.PROMPT_TOOLTIP_TEXT' | translate"
          >
            info_outline
          </mat-icon>
        </glxy-label>
        <textarea
          matInput
          formControlName="instructions"
          rows="15"
          class="prompt-textarea"
          placeholder="{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.PROMPT_PLACEHOLDER' | translate }}"
        ></textarea>
        @if (promptModule.controls.instructions.errors?.['templateSyntax']) {
          <glxy-error>{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.PROMPT_VALIDATION_ERROR' | translate }}</glxy-error>
        } @else {
          <glxy-hint>{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.PROMPT_HELP_TEXT' | translate }}</glxy-hint>
        }
      </glxy-form-field>
    }
  </div>
</form>
<div #inlineFormContainer></div>
<glxy-form-field class="tools-label">
  <glxy-label>
    {{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.FUNCTIONS' | translate }}
  </glxy-label>
</glxy-form-field>
<ai-tools-list
  [forms]="capabilityForm().controls.tools"
  [showAddButton]="capabilityForm().enabled"
  [allowRemovingAnyTools]="allowRemovingAnyTools()"
  [assistantType]="assistantType()"
  (toolFormDisplay)="toolFormDisplay.emit($event)"
/>
